import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import FilesListItem from './FilesListItem'
import FilesListItemArchive from './FilesListItemArchive'

class FilesList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      files: props.files || [],
      currentNativeTypeId: this.getNativeTypeId(props.files),
      nativeFilesCount: props.files.map(file => (file.itemFileInfos ? file.itemFileInfos.filter(fileInfo => fileInfo.attributes.nativeFormat).length : 0))
        .reduce((accumulator, currentValue) => accumulator + currentValue),
      nativeCheckDisabled: false,
    }

    this.getNativeTypeId = this.getNativeTypeId.bind(this)
    this.onFileNativeTrigger = this.onFileNativeTrigger.bind(this)
    this.onAllNativeUncheck = this.onAllNativeUncheck.bind(this)
    this.removeFile = this.removeFile.bind(this)
    this.onRemoveFileSuccess = this.onRemoveFileSuccess.bind(this)
    this.updateFileAttribute = this.updateFileAttribute.bind(this)
    this.onFileInfoUpdate = this.onFileInfoUpdate.bind(this)
    this.addNewFileInfo = this.addNewFileInfo.bind(this)
    this.onNewFileInfoAdd = this.onNewFileInfoAdd.bind(this)
    this.removeFileInfo = this.removeFileInfo.bind(this)
    this.onFileInfoRemove = this.onFileInfoRemove.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.files !== this.props.files) {
      this.setState({ files: this.props.files })
    }
  }

  getNativeTypeId(files) {
    let typeId
    files.forEach((file) => {
      const fileInfo = file.itemFileInfos.find(fileInfo => fileInfo.attributes.nativeFormat)
      if (fileInfo) { typeId = fileInfo.attributes.fileTypeId }
    })
    return typeId || ''
  }

  onFileNativeTrigger(fileId, fileInfoId, fileTypeId, isNative) {
    if ((this.state.currentNativeTypeId === fileTypeId || this.state.currentNativeTypeId === '') && isNative) {
      this.setState(prevState => ({
        nativeFilesCount: prevState.nativeFilesCount + 1,
        currentNativeTypeId: fileTypeId,
      }))
    }

    if (!isNative) {
      this.setState(prevState => ({
        nativeFilesCount: prevState.nativeFilesCount - 1,
      }))

      if (this.state.nativeFilesCount - 1 === 0) {
        this.setState({ currentNativeTypeId: '' })
      }
    }

    if (this.state.currentNativeTypeId !== fileTypeId && this.state.currentNativeTypeId !== '') {
      this.setState({ nativeCheckDisabled: true })
      this.updatingInfoIds = []

      this.state.files.forEach((file) => {
        file.itemFileInfos.forEach((fileInfo) => {
          if (fileTypeId !== fileInfo.attributes.fileTypeId && fileInfo.attributes.nativeFormat && fileInfoId !== fileInfo.attributes.id) {
            this.updatingInfoIds.push(fileInfo.attributes.id)
            axios.patch(`/api/internal/items/${this.props.itemId}/item_files/${file.id}/item_file_infos/${fileInfo.id}`, {
              item_file_info: { native_format: false },
            })
              .then((response) => this.onAllNativeUncheck(response, fileId, fileInfo))
              .catch(() => App.events.publish('app:notification:flash:error', 'Something went wrong while updating native format information.'))
          }
        })
      })
    }

    this.updateFileAttribute(fileId, fileInfoId, 'nativeFormat', isNative)
    if (isNative) { this.setState({ currentNativeTypeId: fileTypeId }) }
  }

  onAllNativeUncheck(response, fileId, fileInfo) {
    fileInfo.attributes.nativeFormat = false
    this.updatingInfoIds = this.updatingInfoIds.filter(item => item !== fileInfo.attributes.id)
    this.onFileInfoUpdate(response, fileId, fileInfo.attributes.id)

    if (this.updatingInfoIds.length <= 1) {
      this.setState({ nativeCheckDisabled: false })
    }
  }

  removeFile(id) {
    if (this.props.itemStatus === 'published' && this.state.files.length === 1) {
      App.events.publish('app:notification:flash:error', 'You cannot delete all files from a published model.')
      return null
    }

    axios.delete(`/profile/items/${this.props.itemId}/uploads/${id}`, {
      attributes: { data: { id, type: 'file' } },
    })
      .then(this.onRemoveFileSuccess(id))
      .catch(() => App.events.publish('app:notification:flash:error', 'File could not be deleted'))
  }

  onRemoveFileSuccess(id) {
    const removedFile = this.state.files.find(file => file.id === id)
    const files = this.state.files.filter(file => file.id !== id)

    this.setState({ files })
    this.props.onChange(files, null, removedFile ? removedFile.name : null)
  }

  updateFileAttribute(fileId, fileInfoId, attribute, value) {
    const attr = attribute.split(/(?=[A-Z])/).join('_').toLowerCase()

    if (attribute === 'rendererVersion' || attribute === 'version') {
      const attributeIsValid = value.length <= 50 && /^[-.,A-Za-z0-9 ]+$/i.test(value)

      if (!attributeIsValid) {
        return null
      }
    }

    axios.patch(`/api/internal/items/${this.props.itemId}/item_files/${fileId}/item_file_infos/${fileInfoId}`, {
      item_file_info: { [attr]: value },
    })
      .then((response) => this.onFileInfoUpdate(response, fileId, fileInfoId))
      .catch(() => App.events.publish('app:notification:flash:error', 'File info could not be updated.'))
  }

  onFileInfoUpdate(response, fileId, fileInfoId) {
    const currentFiles = this.state.files
    const updatedFileInfo = response.data.data
    const fileToUpdateIndex = currentFiles.findIndex(file => file.id === fileId)
    const fileInfoToUpdateIndex = currentFiles[fileToUpdateIndex].itemFileInfos.findIndex(fileInfo => fileInfo.id === fileInfoId)

    const updatedFile = update(currentFiles[fileToUpdateIndex], { itemFileInfos: { [fileInfoToUpdateIndex]: { $set: updatedFileInfo } } })
    const newFiles = update(currentFiles, { $splice: [[fileToUpdateIndex, 1, updatedFile]] })

    this.setState({ files: newFiles })
    this.props.onChange(newFiles, updatedFileInfo)
  }

  addNewFileInfo(fileId) {
    axios.post(`/api/internal/items/${this.props.itemId}/item_files/${fileId}/item_file_infos`, {
      item_file_info: { native_format: false },
    })
      .then((response) => this.onNewFileInfoAdd(response, fileId))
      .catch(() => App.events.publish('app:notification:flash:error', 'New file info could not be added.'))
  }

  onNewFileInfoAdd(response, fileId) {
    const currentFiles = this.state.files
    const newFileInfo = response.data.data
    const itemFileInfos = this.state.files.find(file => file.id === fileId).itemFileInfos

    itemFileInfos.push(newFileInfo)

    const fileToUpdateIndex = currentFiles.findIndex(file => file.id === fileId)
    const updatedFile = update(currentFiles[fileToUpdateIndex], { itemFileInfos: { $set: itemFileInfos } })
    const newFiles = update(currentFiles, { $splice: [[fileToUpdateIndex, 1, updatedFile]] })

    this.setState({ files: newFiles })
    this.props.onChange(newFiles)
  }

  removeFileInfo(fileId, fileInfoId) {
    const currentFiles = this.state.files

    const fileToUpdateIndex = currentFiles.findIndex(file => file.id === fileId)
    const fileInfoToRemoveIndex = currentFiles[fileToUpdateIndex].itemFileInfos.findIndex(fileInfo => fileInfo.id === fileInfoId)

    if (currentFiles[fileToUpdateIndex].itemFileInfos.length === 1) {
      App.events.publish('app:notification:flash:error', 'You must specify at least one file info.')
      return null
    }

    axios.delete(`/api/internal/items/${this.props.itemId}/item_files/${fileId}/item_file_infos/${fileInfoId}`)
      .then(() => this.onFileInfoRemove(fileToUpdateIndex, fileInfoToRemoveIndex))
      .catch(() => App.events.publish('app:notification:flash:error', 'File info could not be removed.'))
  }

  onFileInfoRemove(fileToUpdateIndex, fileInfoToRemoveIndex) {
    const currentFiles = this.state.files
    const updatedFile = update(currentFiles[fileToUpdateIndex], { itemFileInfos: { $splice: [[fileInfoToRemoveIndex, 1]] } })
    const newFiles = update(currentFiles, { $splice: [[fileToUpdateIndex, 1, updatedFile]] })

    this.setState({ files: newFiles })
    this.props.onChange(newFiles)
  }

  render() {
    const fileTypesSelect = this.props.fileTypes.map(fileType => ({ value: fileType.id, label: fileType.title }))

    return (
      <div className="files-list">
        {this.state.files.filter(file => !file.archive).map(file => (
          <FilesListItem
            key={`${file.id}-native-${file.itemFileInfos.length > 0 ? file.itemFileInfos[0].attributes.nativeFormat : ''}`}
            file={file}
            fileTypes={this.props.fileTypes}
            fileTypesForSelect={fileTypesSelect}
            removeFile={this.removeFile}
            updateFileAttribute={this.updateFileAttribute}
            onFileNativeTrigger={this.onFileNativeTrigger}
            nativeCheckDisabled={this.state.nativeCheckDisabled}
          />
        ))}

        {this.state.files.filter(file => file.archive).length > 0 && (
          <Fragment>
            <div className="section-heading">Archived files</div>

            {this.state.files.filter(file => file.archive).map(file => (
              <FilesListItemArchive
                key={`${file.id}-native-${file.itemFileInfos.length > 0 ? file.itemFileInfos.map(info => info.attributes.nativeFormat).join(',') : ''}`}
                file={file}
                fileTypes={this.props.fileTypes}
                fileTypesForSelect={fileTypesSelect}
                removeFile={this.removeFile}
                updateFileAttribute={this.updateFileAttribute}
                addNewFileInfo={this.addNewFileInfo}
                removeFileInfo={this.removeFileInfo}
                onFileNativeTrigger={this.onFileNativeTrigger}
                nativeCheckDisabled={this.state.nativeCheckDisabled}
              />
            ))}
          </Fragment>
        )}
      </div>
    )
  }
}

FilesList.propTypes = {
  itemId: PropTypes.string.isRequired,
  itemStatus: PropTypes.string.isRequired,
  files: PropTypes.array.isRequired,
  fileTypes: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default FilesList
